import { TScheduledPushStatus } from 'types';

export const scheduledPushStatuses: TScheduledPushStatus[] = ['Scheduled', 'Sent', 'Failed'];
